import { Container, Content, Icon, Icons, Subtitle, Title, Wrapper } from './styles';

export type PromoProps = {
    href: string;
    icons: { alt: string; filename: string }[];
    title: string;
    subtitle: string;
};

const Promo = ({ href, icons = [], title, subtitle }: PromoProps) => (
    <Container href={href}>
        <Wrapper align="center" wrap="nowrap" gap={2}>
            {icons.length > 0 && (
                <Icons>
                    {icons.map(({ alt, filename }) => (
                        <Icon alt={alt} key={alt} src={filename} />
                    ))}
                </Icons>
            )}
            <Content>
                <Title>{title}</Title>
                <Subtitle>{subtitle}</Subtitle>
            </Content>
        </Wrapper>
    </Container>
);

export default Promo;
